module.exports = __webpack_public_path__ + "nc_static/media/sw-recall.70253211.svg";